import { useEffect } from 'react'

/** Opens a room socket once the player identity is known and closes it on unmount/route change. */
export function useConnectRoom(
  code: string,
  playerId: string | undefined,
  socketStore: { getState: () => { connect: (code: string) => void; disconnect: () => void } },
) {
  useEffect(() => {
    if (!playerId) return
    socketStore.getState().connect(code)
    return () => socketStore.getState().disconnect()
  }, [playerId, code, socketStore])
}
